export default "__VITE_ASSET___I_c7LU0__"